import { TRANSFER_BY_ACCOUNT_STEPS } from "constants/enum";
import { createStore, createHook, StoreActionApi } from "react-sweet-state";
import { DomesticBankType } from "@/modules/transfer-money/transfer-by-account/components/transfer-by-account-step-1/types";
import {
  BankAccountInfo,
  BranchInfo,
  CorpTransferInternal,
  CreditNumberInfoCoreBank,
  InitCorpTransferInternal,
  PromocyInfo,
  ProvinceInfo,
  SourceAccountStoreType,
  TransferByAccountState,
  TransferInfoByAccount,
} from "./transferByAccountType.d";

export const TRANSFER_BY_ACCOUNT_STORE = "StoreTransferByAccount";

type StoreApi = StoreActionApi<TransferByAccountState>;

export const initialState: TransferByAccountState = {
  actived: TRANSFER_BY_ACCOUNT_STEPS.STEP_ONE,
  categoryCode: "",
  isBackFromStepTwo: false,
  transferInfo: {
    bankReceiver: "",
    numberCard: "",
    accNameReceiver: "",
    moneyNumber: 0,
    transferMethod: "",
    contentInput: "",
    savedAccount: false,
    branchSelected: "",
    provinceSelected: "",
    transferType: "",
    aliasSavedAccount: "",
    expectedDate: new Date(),
    maxLengthMes: 0,
  },
  creditNumberInfo: {
    creditAccountNo: "",
    creditName: "",
    creditPhone: "",
    debitAccountNo: "",
    inputType: "",
    inputValue: "",
    resultCode: "",
    resultDesc: "",
  },
  promocyInfo: {
    otpStatus: "",
    productCode: "",
    promocy: [],
    toAmount: 0,
    totalAmount: 0,
    resultCode: "",
    resultDesc: "",
  },
  bankAccountInfo: {
    bankAccountDesc: "",
    bankAccountNo: "",
    bankTraceNumber: "",
    benefitBankId: "",
    resultCode: "",
    resultDesc: "",
  },
  bankInfo: {
    bankCode: "",
    bankDescription: "",
    bankId: "",
    bankName: "",
    bankType: "",
    benId: "",
    cashinFrCard: "",
    cashinFrIb: "",
    citadBankId: "",
    hintName: "",
    ibLink: "",
    ibft: "",
    image: "",
    isCategory: "",
    napasCategoryCode: "",
    priorityOrder: "",
    shortName: "",
  },
  initCorpTransferInternal: {
    otpStatus: "",
    resultCode: "",
    resultDesc: "",
    transId: "",
  },
  initCorpTransferOtherBankByAccount: {
    otpStatus: "",
    resultCode: "",
    resultDesc: "",
    transId: "",
  },
  initCorpTransferViaCitad: {
    otpStatus: "",
    resultCode: "",
    resultDesc: "",
    transId: "",
  },
  provinceInfo: {
    CITAD_REGION: "",
    ORDER_ID: "",
    PROVINCE_CODE: "",
    PROVINCE_NAME: "",
    PROVINCE_REGION: "",
    RECORD_STAT: "",
    REGION_BACKUP: "",
    ROUTE_BACKUP: "",
    ROUTE_CODE: "",
  },
  branchInfo: {
    ADDRESS: "",
    BANK_NAME: "",
    CITAD_CODE: "",
    DIRECT_CODE: "",
    DISPLAY_BRANCH_NAME: "",
    INDIRECT_CODE: "",
    MA_NH: "",
    MA_TINH: "",
    NAME_OF_BANK: "",
  },
  listBranchInfo: [],
  listProvinceInfo: [],
  corpTransferInternal: {
    paymentStatus: "",
    resultCode: "",
    resultDesc: "",
  },
  corpTransferOtherBankByAccount: {
    paymentStatus: "",
    resultCode: "",
    resultDesc: "",
  },
  corpTransferViaCitad: {
    paymentStatus: "",
    resultCode: "",
    resultDesc: "",
  },
  sourceAccount: {
    icon: "",
    isLinkAccount: false,
    msgMaxLength: 0,
    orderNo: 0,
    paymentType: "",
    primarySource: "",
    sourceDefault: "",
    sourceDisplayName: "",
    sourceGroup: "",
    sourceId: "",
    sourceObjectName: "",
    sourceObjectNumber: "",
    sourceType: "",
    availableBalance: 0,
  },
};

export const actions = {
  setIsBackFromStepTwo:
    (isBackFromStepTwo: boolean) =>
    ({ setState, getState }: StoreApi) => {
      const prevState = getState();
      setState({
        ...prevState,
        isBackFromStepTwo,
      });
    },
  setSourceAccount:
    (sourceAccount: SourceAccountStoreType) =>
    ({ setState, getState }: StoreApi) => {
      const prevState = getState();
      setState({
        ...prevState,
        sourceAccount,
      });
    },
  setCorpTransferViaCitad:
    (corpTransferViaCitad: CorpTransferInternal) =>
    ({ setState, getState }: StoreApi) => {
      const prevState = getState();
      setState({
        ...prevState,
        corpTransferViaCitad,
      });
    },
  setCorpTransferOtherBankByAccount:
    (corpTransferOtherBankByAccount: CorpTransferInternal) =>
    ({ setState, getState }: StoreApi) => {
      const prevState = getState();
      setState({
        ...prevState,
        corpTransferOtherBankByAccount,
      });
    },
  setCorpTransferInternal:
    (corpTransferInternal: CorpTransferInternal) =>
    ({ setState, getState }: StoreApi) => {
      const prevState = getState();
      setState({
        ...prevState,
        corpTransferInternal,
      });
    },
  setListBranchInfo:
    (listBranchInfo: BranchInfo[]) =>
    ({ setState, getState }: StoreApi) => {
      const prevState = getState();
      setState({
        ...prevState,
        listBranchInfo,
      });
    },
  setBranchInfo:
    (branchInfo: BranchInfo) =>
    ({ setState, getState }: StoreApi) => {
      const prevState = getState();
      setState({
        ...prevState,
        branchInfo,
      });
    },
  setListProvinceInfo:
    (listProvinceInfo: ProvinceInfo[]) =>
    ({ setState, getState }: StoreApi) => {
      const prevState = getState();
      setState({
        ...prevState,
        listProvinceInfo,
      });
    },
  setProvinceInfo:
    (provinceInfo: ProvinceInfo) =>
    ({ setState, getState }: StoreApi) => {
      const prevState = getState();
      setState({
        ...prevState,
        provinceInfo,
      });
    },
  resetProvinceInfo:
    () =>
    ({ setState, getState }: StoreApi) => {
      const prevState = getState();
      setState({
        ...prevState,
        provinceInfo: initialState.provinceInfo,
      });
    },
  resetBranchInfo:
    () =>
    ({ setState, getState }: StoreApi) => {
      const prevState = getState();
      setState({
        ...prevState,
        branchInfo: initialState.branchInfo,
      });
    },
  setInitCorpTransferOtherBankByAccount:
    (initCorpTransferOtherBankByAccount: InitCorpTransferInternal) =>
    ({ setState, getState }: StoreApi) => {
      const prevState = getState();
      setState({
        ...prevState,
        initCorpTransferOtherBankByAccount,
      });
    },
  setInitCorpTransferInternal:
    (initCorpTransferInternal: InitCorpTransferInternal) =>
    ({ setState, getState }: StoreApi) => {
      const prevState = getState();
      setState({
        ...prevState,
        initCorpTransferInternal,
      });
    },
  setInitCorpTransferViaCitad:
    (initCorpTransferViaCitad: InitCorpTransferInternal) =>
    ({ setState, getState }: StoreApi) => {
      const prevState = getState();
      setState({
        ...prevState,
        initCorpTransferViaCitad,
      });
    },
  setBankInfo:
    (bankInfo: DomesticBankType) =>
    ({ setState, getState }: StoreApi) => {
      const prevState = getState();
      setState({
        ...prevState,
        bankInfo,
      });
    },
  setBankAccountInfo:
    (bankAccountInfo: BankAccountInfo) =>
    ({ setState, getState }: StoreApi) => {
      const prevState = getState();
      setState({
        ...prevState,
        bankAccountInfo,
      });
    },
  setPromocy:
    (promocyInfo: PromocyInfo) =>
    ({ setState, getState }: StoreApi) => {
      const prevState = getState();
      setState({
        ...prevState,
        promocyInfo,
      });
    },
  setCreditNumberInfo:
    (creditNumberInfo: CreditNumberInfoCoreBank) =>
    ({ setState, getState }: StoreApi) => {
      const prevState = getState();
      setState({
        ...prevState,
        creditNumberInfo,
      });
    },
  setTransferInfo:
    (transferInfo: TransferInfoByAccount) =>
    ({ setState, getState }: StoreApi) => {
      const prevState = getState();
      setState({
        ...prevState,
        transferInfo,
      });
    },
  resetTransferInfo:
    () =>
    ({ setState, getState }: StoreApi) => {
      const prevState = getState();
      setState({
        ...prevState,
        transferInfo: initialState.transferInfo,
      });
    },
  setCategoryCode:
    (categoryCode: string) =>
    ({ setState, getState }: StoreApi) => {
      const prevState = getState();
      setState({
        ...prevState,
        categoryCode,
      });
    },
  setActived:
    (active: number) =>
    ({ setState, getState }: StoreApi) => {
      const prevState = getState();
      setState({
        ...prevState,
        actived: active,
      });
    },
  clearStore:
    () =>
    ({ setState }: StoreApi) => {
      setState({
        ...initialState,
      });
    },
};

type Actions = typeof actions;

const Store = createStore<TransferByAccountState, Actions>({
  initialState,
  actions,
  name: TRANSFER_BY_ACCOUNT_STORE,
});

const useTransferByAccountStore = createHook(Store);

export const storeKey = `${Store.key}@__global__`;

export default useTransferByAccountStore;
